module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    staticClass: "content-settings__box content-settings__box--center outer",
    attrs: {
      "name": "imagelist",
      "tag": "div"
    }
  }, _vm._l((_vm.unitlist.items), function(item, index) {
    return (index === _vm.unitlist.selected) ? _c('div', {
      key: item.Model,
      staticClass: "bgimage inner",
      style: ({
        'background-image': 'url(' + item.Image + ')'
      })
    }) : _vm._e()
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5701d8a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/BgImage.vue
// module id = 237
// module chunks = 0